export default "__VITE_ASSET__u$7gcUjZ__"